import { Badge } from "@/components/ui/badge"
import { BriefStatus } from "@/types/contents"

type StatusColor = "gray" | "success" | "warning"

const STATUS_COLORS: Record<BriefStatus, StatusColor> = {
  [BriefStatus.archived]: "warning",
  [BriefStatus.draft]: "gray",
  [BriefStatus.published]: "success",
}

export function CollabStatusBadge({ status }: { status: string }) {
  return (
    <Badge
      color={STATUS_COLORS[status as BriefStatus] ?? "gray"}
      size="sm"
      type="pill-color"
      className="capitalize"
    >
      {status}
    </Badge>
  )
}
